<style lang="less" scoped>
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .in-sec {
    width: 1200px; margin: 0 auto;
    text-align: center; padding: 79px 0 160px 0;
  }
  h2 {
    margin: 0 auto; line-height: 60px; display: inline-block;
    border: 2px solid #8cf7fb; font-family: 'DINPro-B'; font-size: 26px;
    padding: 0 53px; border-radius: 32px; background-color: #fff;
    box-shadow: 0 5px 10px rgba(51, 55, 64, .09);
  }
  ul {
    display: flex; padding: 80px 0 150px 0;
    background: url('~@/assets/line-1.png') no-repeat center bottom;
    li {
      flex: 1; font-size: 16px; padding-bottom: 18px;
      img {
        display: block; margin: 0 auto;
      }
      &:nth-child(2) {
        border: 1px #f0f0f0; border-style: none solid;
      }
      strong {
        color: #1170fe; font-size: 20px; padding-bottom: 13px; display: block;
      }
      p {
        line-height: 140%;
      }
    }
  }
  h3 {
    position: relative; font-size: 28px; display: inline-block; margin: 0 auto;
    background-color: #1170fe; color: #fff; font-family: 'NotoSansKR_R';
    font-weight: normal; line-height: 170%; padding: 42px 100px;
    border-radius: 90px; margin-top: -19px;
    box-shadow: 0 5px 10px rgba(51, 55, 64, .09);
    &::after {
      content: ''; display: block; width: 6px; height: 6px; top: 10px;
      border-radius: 100%; background-color: #8bf7fa; .abs-lcenter;
    }
  }
  @media only screen and (max-width: 768px) {
    .in-sec {
      width: auto; padding: 40px 0 80px 0;
    }
    h2 {
      font-size: 13px; line-height: 30px; border-radius: 15px;
      padding: 0 25px;
    }
    ul {
      display: flex; padding: 40px 0 65px 0;
      background: url('~@/assets/line-1.png') no-repeat center bottom;
      background-size: 70% auto;
      li {
        flex: 1; font-size: 10px; padding-bottom: 18px;
        img {
          display: block; margin: 0 auto; width: 100%;
        }
        &:nth-child(2) {
          border: 1px #f0f0f0; border-style: none solid;
        }
        strong {
          color: #1170fe; font-size: 12px; padding-bottom: 13px; display: block;
        }
        p {
          line-height: 140%;
        }
      }
    }
    h3 {
      font-size: 12px; padding: 22px 39px; margin-top: -10px;
    }
  }
</style>

<template lang="pug">
  .solution-container
    .in-sec
      h2 SOLUTION
      ul
        li
          img(src="~@/assets/solution-1.png")
          strong 오네버스
          p IoT 기반#[br]어린이 안심 통학솔루션
        li
          img(src="~@/assets/solution-2.png")
          strong ULiveBUS
          p 기업형 통근 버스#[br]차량 보안관제 솔루션
        li
          img(src="~@/assets/solution-3.png")
          strong 지하철팝
          p IoT 기반#[br]철도 통합정보 솔루션
      h3 통합 위치관제 플랫폼#[br]IoT 처리 집계 플랫폼
</template>

<script>
export default {

};
</script>
